import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
// import { ProfileService } from 'app/layouts/profiles/profile.service';

@Component({
  selector: 'cbic-inner-component',
  templateUrl: './inner-component.component.html',
  styleUrls: ['./inner-component.component.scss']
})
export class InnerComponentComponent  { //  implements OnInit
  @Input() inputData: any;
  inProduction:any;
  openAPIEnabled:any;
  constructor(  
    // private profileService: ProfileService,
     private elementRef: ElementRef,
     private scrollHere:ElementRef,
     private changeDedectionRef: ChangeDetectorRef) { }

  // ngOnInit(): void {
	  
  //   // this.profileService.getProfileInfo().subscribe(profileInfo => {
  //   //   this.inProduction = profileInfo.inProduction;
  //   //   this.openAPIEnabled = profileInfo.openAPIEnabled;
  //   // });
  // }

}
